import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import PatternCardItem from './PatternCardItem';

export default class PatternGroup extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene
   */
  constructor(scene,patternArr) {
    super(scene);

    this.spacing = 10;
    const sizeCard = this.scene.textures.getFrame(ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._card_bg);
    this.patternItemWidth = sizeCard.realWidth + this.spacing;
    this.patternItemHeight = sizeCard.realHeight;
    this.patternWidth = -this.spacing;
    this.pattern = [];

    // create and position cards
    for (let i = 0; i < patternArr.length; i++) {
      const patternPart = {};
      if (patternArr[i].filled === true) {
        patternPart.partDisplay = new PatternCardItem(this.scene, patternArr[i].val);
      }
      else {
        // add a stroke box to show where a card can be dropped
        const dropbox = this.scene.add.graphics({ lineStyle: { color: 0xd9dbdc, width: 4, alpha: 0.5 } }).strokeRoundedRect(0,0,sizeCard.realWidth,sizeCard.realHeight, 10);
        patternPart.placeholder = dropbox;
      }

      patternPart.isFilled = patternArr[i].filled;
      patternPart.patternValue = patternArr[i].val;
      this.pattern.push(patternPart);
      this.patternWidth += this.patternItemWidth;
    }
  }

  checkIndexVal (patternIndex) {
    return this.pattern[patternIndex].patternValue;
  }

  checkIndexFilled (patternIndex) {
    return this.pattern[patternIndex].isFilled;
  }

  /**
   * 
   * @param {number} addIndex 
   * @param {PatternCardItem} displayItem 
   */
  addToPatternAt (addIndex,displayItem) {
    this.add(displayItem);
    displayItem.setPosition(addIndex * this.patternItemWidth, 0);
    this.pattern[addIndex].partDisplay = displayItem;
    this.pattern[addIndex].isFilled = true;
    this.pattern[addIndex].placeholder?.destroy();

    // check if all filled
    let complete = true;
    let i = 0;
    while (i < this.pattern.length) {
      if (this.pattern[i].isFilled === false) {
        complete = false;
        break;
      }
      i++;
    }

    if (complete) {
      this.emit('PATTERN_COMPLETE');
    }
  }

  showHint () {
    let hintIndex = -1;
    for (let i = 0; i < this.pattern.length; i++) {
      const filled = this.checkIndexFilled(i);
      if (!filled) {
        hintIndex = i;
        break;
      }
    }

    if (hintIndex !== -1) {
      this.hintMark = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._place_marker, this).setOrigin(0.5, 0);
      this.hintMark.x = hintIndex * this.patternItemWidth + (this.patternItemWidth / 2) - this.spacing / 2;
      this.hintMark.y = (this.patternItemHeight / 2) - (this.hintMark.height / 2);
      this.hintMark.scaleY = 0;
      ABCyaPhaser.Tweens.addTween(this.hintMark, 300, { delay: 100 * hintIndex, scaleY: 1 }, Phaser.Math.Easing.Quadratic.Out);
    }
  }

  showPattern () {
    for (let i = 0; i < this.pattern.length; i++) {
      const part = this.pattern[i];
      if (part.partDisplay !== undefined && part.partDisplay !== null) {
        part.partDisplay.x = i * this.patternItemWidth;
        part.partDisplay.scaleY = 0;
        this.add(part.partDisplay);
        ABCyaPhaser.Tweens.addTween(part.partDisplay, 300, { delay: 100 * i, scaleY: 1 }, Phaser.Math.Easing.Quadratic.Out);
      }
      else if (part.placeholder !== undefined && part.placeholder !== null) {
        part.placeholder.x = i * this.patternItemWidth;
        part.placeholder.scaleY = 0;
        this.add(part.placeholder);
        ABCyaPhaser.Tweens.addTween(part.placeholder, 300, { delay: 100 * i, scaleY: 1 }, Phaser.Math.Easing.Quadratic.Out);
      }
    }

    this.emit('PATTERN_SHOWN');
  }
}